import httpClient from './httpClient';
import { getTenantConfig } from '../../config/tenantConfig';

const getBaseUrl = () => {
  const config = getTenantConfig();
  return config.api.witnessStatement;
};

export const statementSourceTagService = {
  async listSourceTags(filters = {}) {
    const params = new URLSearchParams();
    if (filters.category) {
      params.append('category', filters.category);
    }

    const url = `${getBaseUrl()}/source-tags${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await httpClient.get(url);
    return response; // httpClient already unwraps response.data
  },

  async getSourceTag(tagId) {
    const response = await httpClient.get(`${getBaseUrl()}/source-tags/${tagId}`);
    return response; // httpClient already unwraps response.data
  },

  async createSourceTag(tag) {
    const response = await httpClient.post(`${getBaseUrl()}/source-tags`, tag);
    return response; // httpClient already unwraps response.data
  },

  async updateSourceTag(tagId, updates) {
    const response = await httpClient.put(`${getBaseUrl()}/source-tags/${tagId}`, updates);
    return response; // httpClient already unwraps response.data
  },

  async deleteSourceTag(tagId) {
    const response = await httpClient.delete(`${getBaseUrl()}/source-tags/${tagId}`);
    return response; // httpClient already unwraps response.data
  }
};
